import AppConstants from '../config/app.constants';

let IdStoreService = function ($http, $q) {

    // Preview next available Id for location
    let getPreviewNextId = (key, amount) => {
        return $http
            .get(AppConstants.api + `/id-store/preview`, {
                params: {
                    key,
                    amount
                }
            })
            .then((res) => {
                return res.data
            })
    }

    // Increment next available Id for location
    let incrementKey = (key, amount) => {
        return $http
            .post(AppConstants.api + `/id-store/increment`, {
                key,
                amount
            })
            .then((res) => {
                return res.data
            })
    }

    // Prefix for branchId
    let branchIdPrefix = (branchId) => {
        if (typeof branchId !== 'string')
            return undefined;
        return `BRANCH-${branchId}`;
    }

    return {
        getPreviewNextId,
        branchIdPrefix,
        incrementKey
    };
};

IdStoreService.$inject = ['$http', '$q']

export default IdStoreService;


// WEBPACK FOOTER //
// ./client/app/services/id-store-service.js